<template>
  <CommonLayout header="floristHeader" footer="floristFooter" ref="commonRef">
    <MeetingLayout :type="this.consts.meetingType.florist">
      <div class="base-color h-100 mh-550 shadow">
        <div class="customer-info-wrap h-100">
          <h2 class="text-primary pt-3 customer-info-title">【お客様情報入力欄】</h2>
          <form method="post" action="#" class="form-horizontal" autocomplete="off">
            <div class="p-3 mb-3">
              <div class="form-group row">
                <div class="control-label col-sm-12 customer-info-label mb-1">
                  <h2 class="font-weight-bold d-inline">ご両家様名</h2>
                  <span class="required-color d-inline">（*）</span>
                </div>
                <div class="customer-info-block col-4 col-sm-4">
                  <input name="bothFamilyName1" type="text" id="bothFamilyName1" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : validation.hasError('bothFamilyName1')}" v-model="bothFamilyName1" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!isOperationPossible"/>
                  <div class="invalid-feedback">{{ validation.firstError('bothFamilyName1') }}</div>
                </div>
                <div class="col-1 col-sm-1 p-2 text-center">
                  <span>・</span>
                </div>
                <div class="customer-info-block col-4 col-sm-4">
                  <input name="bothFamilyName2" type="text" id="bothFamilyName2" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : validation.hasError('bothFamilyName2')}" v-model="bothFamilyName2" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!isOperationPossible"/>
                  <div class="invalid-feedback">{{ validation.firstError('bothFamilyName2') }}</div>
                </div>
                <div class="col-3 col-sm-3 p-2">
                  <span>ご両家様</span>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-12 customer-info-label">
                  <div class="custom-control custom-radio custom-control-inline align-items-center" :class="{'is-invalid' : validation.hasError('shinroShinpu1')}">
                    <input class="form-check-input meeting-input big_radio" name="shinroShinpu1" type="radio" id="inlineRadio1" value="shinro" :class="{'is-invalid' : validation.hasError('shinroShinpu1')}" v-model="shinroShinpu1" @click="sendSignalingInputData" :disabled="!isOperationPossible">
                    <label class="form-check-label ml-1 customer-info-label font-weight-bold" :style="'font-size: 2rem;' + (shinroShinpu1 != 'shinro' ? 'color: gray;' : 'color: black;')" for="inlineRadio1">ご新郎様</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline align-items-center" :class="{'is-invalid' : validation.hasError('shinroShinpu1')}">
                    <input class="form-check-input meeting-input big_radio" name="shinroShinpu1" type="radio" id="inlineRadio2" value="shinpu" :class="{'is-invalid' : validation.hasError('shinroShinpu1')}" v-model="shinroShinpu1" @click="sendSignalingInputData" :disabled="!isOperationPossible">
                    <label class="form-check-label ml-1 customer-info-label font-weight-bold" :style="'font-size: 2rem;' + (shinroShinpu1 != 'shinpu' ? 'color: gray;' : 'color: black;')" for="inlineRadio2">ご新婦様</label>
                  </div>
                </div>
                <div class="customer-info-block col-sm-6 row">
                  <label for="groomLastName" class="control-label col-sm-12">姓<span class="required-color">（*）</span></label>
                  <div class="col-sm-12">
                    <input name="groomLastName" type="text" id="groomLastName" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : validation.hasError('groomLastName')}" v-model="groomLastName" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!isOperationPossible"/>
                    <div class="invalid-feedback">{{ validation.firstError('groomLastName') }}</div>
                  </div>
                </div>
                <div class="customer-info-block col-sm-6 row">
                  <label for="groomFirstName" class="control-label col-sm-12">名<span class="required-color">（*）</span></label>
                  <div class="col-sm-12">
                    <input name="groomFirstName" type="text" id="groomFirstName" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : validation.hasError('groomFirstName')}" v-model="groomFirstName" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!isOperationPossible"/>
                    <div class="invalid-feedback">{{ validation.firstError('groomFirstName') }}</div>
                  </div>
                </div>
                <div class="col-sm-1 row">
                  <div class="col-sm-12"></div>
                  <div class="w-100 text-right align-self-center pt-3">様</div>
                </div>
                <div class="customer-info-block col-sm-6 row mt-2">
                  <label for="groomLastNameKana" class="control-label col-sm-12">セイ</label>
                  <div class="col-sm-12">
                    <input name="groomLastNameKana" type="text" id="groomLastNameKana" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : validation.hasError('groomLastNameKana')}" v-model="groomLastNameKana" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!isOperationPossible"/>
                    <div class="invalid-feedback">{{ validation.firstError('groomLastNameKana') }}</div>
                  </div>
                </div>
                <div class="customer-info-block col-sm-6 row">
                  <label for="groomFirstNameKana" class="control-label col-sm-12">メイ</label>
                  <div class="col-sm-12">
                    <input name="groomFirstNameKana" type="text" id="groomFirstNameKana" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : validation.hasError('groomFirstNameKana')}" v-model="groomFirstNameKana" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!isOperationPossible"/>
                    <div class="invalid-feedback">{{ validation.firstError('groomFirstNameKana') }}</div>
                  </div>
                </div>
                <div class="col-sm-1 row">
                  <div class="col-sm-12"></div>
                  <div class="w-100 text-right align-self-center pt-3">様</div>
                </div>
                <div class="customer-info-block col-sm-12 row mt-2">
                  <label for="groomPhoneNumber" class="control-label col-sm-12">お電話番号</label>
                  <div class="col-sm-7">
                    <input name="groomPhoneNumber" type="text" id="groomPhoneNumber" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : validation.hasError('groomPhoneNumber')}" v-model="groomPhoneNumber" @change="loadValidate" maxLength="20" @blur="sendSignalingInputData" :disabled="!isOperationPossible"/>
                    <div class="invalid-feedback">{{ validation.firstError('groomPhoneNumber') }}</div>
                  </div>
                </div>
                <div class="control-label col-sm-12 customer-info-label">
                  <label class="d-inline">メールアドレス</label>
                </div>
                <div class="customer-info-block col-sm-12 row">
                  <div class="col-sm-12">
                    <input name="mailAddress" type="text" id="mailAddress" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : validation.hasError('mailAddress')}" v-model="mailAddress" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!isOperationPossible"/>
                    <div class="invalid-feedback">{{ validation.firstError('mailAddress') }}</div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <h1 id="email-disp">{{mailAddress}}</h1>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-12 customer-info-label">
                  <div class="custom-control custom-radio custom-control-inline align-items-center" :class="{'is-invalid' : validation.hasError('shinroShinpu2')}">
                    <input class="form-check-input meeting-input big_radio" name="shinroShinpu2" type="radio" id="inlineRadio3" value="shinro" :class="{'is-invalid' : validation.hasError('shinroShinpu2')}" v-model="shinroShinpu2" @click="sendSignalingInputData" :disabled="!isOperationPossible">
                    <label class="form-check-label ml-1 customer-info-label font-weight-bold" :style="'font-size: 2rem;' + (shinroShinpu2 != 'shinro' ? 'color: gray;' : 'color: black;')" for="inlineRadio3">ご新郎様</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline align-items-center" :class="{'is-invalid' : validation.hasError('shinroShinpu2')}">
                    <input class="form-check-input meeting-input big_radio" name="shinroShinpu2" type="radio" id="inlineRadio4" value="shinpu" :class="{'is-invalid' : validation.hasError('shinroShinpu2')}" v-model="shinroShinpu2" @click="sendSignalingInputData" :disabled="!isOperationPossible">
                    <label class="form-check-label ml-1 customer-info-label font-weight-bold" :style="'font-size: 2rem;' + (shinroShinpu2 != 'shinpu' ? 'color: gray;' : 'color: black;')" for="inlineRadio4">ご新婦様</label>
                  </div>
                </div>
                <div class="customer-info-block col-sm-6 row">
                  <label for="brideLastName" class="control-label col-sm-12">姓<span class="required-color">（*）</span></label>
                  <div class="col-sm-12">
                    <input name="brideLastName" type="text" id="brideLastName" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : validation.hasError('brideLastName')}" v-model="brideLastName" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!isOperationPossible"/>
                    <div class="invalid-feedback">{{ validation.firstError('brideLastName') }}</div>
                  </div>
                </div>
                <div class="customer-info-block col-sm-6 row">
                  <label for="brideFirstName" class="control-label col-sm-12">名<span class="required-color">（*）</span></label>
                  <div class="col-sm-12">
                    <input name="brideFirstName" type="text" id="brideFirstName" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : validation.hasError('brideFirstName')}" v-model="brideFirstName" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!isOperationPossible"/>
                    <div class="invalid-feedback">{{ validation.firstError('brideFirstName') }}</div>
                  </div>
                </div>
                <div class="col-sm-1 row">
                  <div class="col-sm-12"></div>
                  <div class="w-100 text-right align-self-center pt-3">様</div>
                </div>
                <div class="customer-info-block col-sm-6 row mt-2">
                  <label for="brideLastNameKana" class="control-label col-sm-12">セイ</label>
                  <div class="col-sm-12">
                    <input name="brideLastNameKana" type="text" id="brideLastNameKana" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : validation.hasError('brideLastNameKana')}" v-model="brideLastNameKana" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!isOperationPossible"/>
                    <div class="invalid-feedback">{{ validation.firstError('brideLastNameKana') }}</div>
                  </div>
                </div>
                <div class="customer-info-block col-sm-6 row">
                  <label for="brideFirstNameKana" class="control-label col-sm-12">メイ</label>
                  <div class="col-sm-12">
                    <input name="brideFirstNameKana" type="text" id="brideFirstNameKana" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : validation.hasError('brideFirstNameKana')}" v-model="brideFirstNameKana" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!isOperationPossible"/>
                    <div class="invalid-feedback">{{ validation.firstError('brideFirstNameKana') }}</div>
                  </div>
                </div>
                <div class="col-sm-1 row">
                  <div class="col-sm-12"></div>
                  <div class="w-100 text-right align-self-center pt-3">様</div>
                </div>
                <div class="customer-info-block col-sm-12 row mt-2">
                  <label for="bridePhoneNumber" class="control-label col-sm-12">お電話番号</label>
                  <div class="col-sm-7">
                    <input name="bridePhoneNumber" type="text" id="bridePhoneNumber" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : validation.hasError('bridePhoneNumber')}" v-model="bridePhoneNumber" @change="loadValidate" maxLength="20" @blur="sendSignalingInputData" :disabled="!isOperationPossible"/>
                    <div class="invalid-feedback">{{ validation.firstError('bridePhoneNumber') }}</div>
                  </div>
                </div>
                <div class="control-label col-sm-12 customer-info-label">
                  <label class="d-inline">メールアドレス</label>
                </div>
                <div class="customer-info-block col-sm-12 row">
                  <div class="col-sm-12">
                    <input name="brideMailAddress" type="text" id="brideMailAddress" class="form-control input-sm meeting-input" :class="{'is-invalid is-invalid-custom' : validation.hasError('brideMailAddress')}" v-model="brideMailAddress" @change="loadValidate" @blur="sendSignalingInputData" :disabled="!isOperationPossible"/>
                    <div class="invalid-feedback">{{ validation.firstError('brideMailAddress') }}</div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <h1 id="email-disp">{{brideMailAddress}}</h1>
                </div>
              </div>
            </div>
          </form>
          <div class="text-right w-100 mb-3 mr-5">
            <!--<b-button variant="outline-secondary" class="w-25 sub-button-color">戻る</b-button>-->
            <b-button variant="primary" class="w-25 ml-3 main-button-color next-button-disabled" @click="nextPage" :disabled="!isOperationPossible">次へ</b-button>
          </div>
        </div>
      </div>
    </MeetingLayout>
    <CommonModal ref="commonModal" />
  </CommonLayout>
</template>
<script>
import Vue from 'vue'
import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import MeetingLayout from '@/layout/MeetingLayout'
import fstore from '@/store/florist-store'
import SimpleVueValidation from 'simple-vue-validator'
import CustomerInfoModel from '@/models/CustomerInfoModel'
import SignalingModel from '@/models/SignalingModel'
import CommonLogModel from '@/models/CommonLogModel'
const Validator = SimpleVueValidation.Validator

Vue.use(SimpleVueValidation)

export default {
  name: 'FloristMeetingInput',
  components: { CommonLayout, MeetingLayout, CommonModal },
  data () {
    return {
      bothFamilyName1: '',
      bothFamilyName2: '',
      shinroShinpu1: 'shinro',
      shinroShinpu2: 'shinpu',
      groomLastName: '',
      groomFirstName: '',
      groomLastNameKana: '',
      groomFirstNameKana: '',
      groomPhoneNumber: '',
      brideLastNameKana: '',
      brideFirstNameKana: '',
      brideLastName: '',
      brideFirstName: '',
      bridePhoneNumber: '',
      mailAddress: '',
      brideMailAddress: '',
      isOperationPossible: fstore.getters.isOperationPossible
    }
  },
  computed: {
    getSignalingData () {
      return fstore.getters.signalingReceiveData
    },
    getIsOperationPossible () {
      return fstore.getters.isOperationPossible
    }
  },
  created () {
    const lastRoutePath = sessionStorage.getItem('lastRoutePath')
    if (lastRoutePath !== this.$route.path) {
      // 初期状態でfalse
      fstore.commit('setIsOperationPossible', false)
    }
  },
  mounted () {
    try {
      this.setApiData()
    } catch (err) {
      CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
      })
    }
  },
  validators: {
    bothFamilyName1: function (value) { return Validator.value(value).required(this.consts.validationMsg.meetingInput.bothFamilyName1.required).regex(/^[^,\t\r\n]+$/, this.consts.validationMsg.meetingInput.bothFamilyName1.commaTabLineBreak) },
    bothFamilyName2: function (value) { return Validator.value(value).required(this.consts.validationMsg.meetingInput.bothFamilyName2.required).regex(/^[^,\t\r\n]+$/, this.consts.validationMsg.meetingInput.bothFamilyName1.commaTabLineBreak) },
    groomLastName: function (value) { return Validator.value(value).required(this.consts.validationMsg.meetingInput.groomLastName.required) },
    groomFirstName: function (value) { return Validator.value(value).required(this.consts.validationMsg.meetingInput.groomFirstName.required) },
    groomFirstNameKana: function (value) { return Validator.value(value).regex(/^[あ-んァ-ヶーA-Za-zＡ-Ｚａ-ｚ]+$/, this.consts.validationMsg.meetingInput.groomFirstNameKana.kana) },
    groomLastNameKana: function (value) { return Validator.value(value).regex(/^[あ-んァ-ヶーA-Za-zＡ-Ｚａ-ｚ]+$/, this.consts.validationMsg.meetingInput.groomLastNameKana.kana) },
    groomPhoneNumber: function (value) {
      return Validator
        .value(value)
        .maxLength(20, this.consts.validationMsg.meetingInput.groomPhoneNumber.maxLength)
        .regex(/^[+]?[0-9\s-]+$/, this.consts.validationMsg.meetingInput.groomPhoneNumber.phoneNumber)
    },
    brideLastName: function (value) { return Validator.value(value).required(this.consts.validationMsg.meetingInput.brideLastName.required) },
    brideFirstName: function (value) { return Validator.value(value).required(this.consts.validationMsg.meetingInput.brideFirstName.required) },
    brideLastNameKana: function (value) { return Validator.value(value).regex(/^[あ-んァ-ヶーA-Za-zＡ-Ｚａ-ｚ]+$/, this.consts.validationMsg.meetingInput.brideLastNameKana.kana) },
    brideFirstNameKana: function (value) { return Validator.value(value).regex(/^[あ-んァ-ヶーA-Za-zＡ-Ｚａ-ｚ]+$/, this.consts.validationMsg.meetingInput.brideFirstNameKana.kana) },
    bridePhoneNumber: function (value) {
      return Validator
        .value(value)
        .maxLength(20, this.consts.validationMsg.meetingInput.groomPhoneNumber.maxLength)
        .regex(/^[+]?[0-9\s-]+$/, this.consts.validationMsg.meetingInput.groomPhoneNumber.phoneNumber)
    },
    mailAddress: function (value) {
      if (this.brideMailAddress.trim()) {
        return Validator
          .value(value)
          .email(this.consts.validationMsg.meetingInput.mailAddress.email)
          .regex(/^[\x20-\x7e]*$/, this.consts.validationMsg.meetingInput.mailAddress.halfWidth)
      } else {
        return Validator
          .value(value)
          .required(this.consts.validationMsg.meetingInput.mailAddress.required)
          .email(this.consts.validationMsg.meetingInput.mailAddress.email)
          .regex(/^[\x20-\x7e]*$/, this.consts.validationMsg.meetingInput.mailAddress.halfWidth)
      }
    },
    brideMailAddress: function (value) {
      if (this.mailAddress.trim()) {
        return Validator
          .value(value)
          .email(this.consts.validationMsg.meetingInput.mailAddress.email)
          .regex(/^[\x20-\x7e]*$/, this.consts.validationMsg.meetingInput.mailAddress.halfWidth)
      } else {
        return Validator
          .value(value)
          .required(this.consts.validationMsg.meetingInput.mailAddress.required)
          .email(this.consts.validationMsg.meetingInput.mailAddress.email)
          .regex(/^[\x20-\x7e]*$/, this.consts.validationMsg.meetingInput.mailAddress.halfWidth)
      }
    }
  },
  // validators: {
  //   bothFamilyName1: function (value) { return Validator.value(value).required(this.consts.validationMsg.meetingInput.bothFamilyName1.required) },
  //   bothFamilyName2: function (value) { return Validator.value(value).required(this.consts.validationMsg.meetingInput.bothFamilyName2.required) },
  //   groomLastName: function (value) { return Validator.value(value).required(this.consts.validationMsg.meetingInput.groomLastName.required) },
  //   groomFirstName: function (value) { return Validator.value(value).required(this.consts.validationMsg.meetingInput.groomFirstName.required) },
  //   groomFirstNameKana: function (value) { return Validator.value(value).regex(/^[ァ-ヶー]+$/, this.consts.validationMsg.meetingInput.groomFirstNameKana.kana) },
  //   groomLastNameKana: function (value) { return Validator.value(value).regex(/^[ァ-ヶー]+$/, this.consts.validationMsg.meetingInput.groomLastNameKana.kana) },
  //   groomPhoneNumber: function (value) {
  //     return Validator
  //       .value(value)
  //       .required(this.consts.validationMsg.meetingInput.groomPhoneNumber.required)
  //       .integer(this.consts.validationMsg.meetingInput.groomPhoneNumber.integer)
  //       .maxLength(11, this.consts.validationMsg.meetingInput.groomPhoneNumber.maxLength)
  //   },
  //   brideLastName: function (value) { return Validator.value(value).required(this.consts.validationMsg.meetingInput.brideLastName.required) },
  //   brideFirstName: function (value) { return Validator.value(value).required(this.consts.validationMsg.meetingInput.brideFirstName.required) },
  //   brideLastNameKana: function (value) { return Validator.value(value).regex(/^[ァ-ヶー]+$/, this.consts.validationMsg.meetingInput.groomFirstNameKana.kana) },
  //   brideFirstNameKana: function (value) { return Validator.value(value).regex(/^[ァ-ヶー]+$/, this.consts.validationMsg.meetingInput.groomLastNameKana.kana) },
  //   bridePhoneNumber: function (value) {
  //     return Validator
  //       .value(value)
  //       .required(this.consts.validationMsg.meetingInput.bridePhoneNumber.required)
  //       .integer(this.consts.validationMsg.meetingInput.bridePhoneNumber.integer)
  //       .maxLength(11, this.consts.validationMsg.meetingInput.groomPhoneNumber.maxLength)
  //   },
  //   mailAddress: function (value) {
  //     return Validator
  //       .value(value)
  //       .required(this.consts.validationMsg.meetingInput.mailAddress.required)
  //       .email(this.consts.validationMsg.meetingInput.mailAddress.email)
  //   },
  //   mailAddressType: function (value) { return Validator.value(value).required(this.consts.validationMsg.meetingInput.mailAddressType.required) }
  // },
  watch: {
    getSignalingData (newData, oldData) {
      try {
        newData['user'] = 'florist'
        newData['timestampMs'] = Date.now()
        CommonLogModel.apiSetStore(this.$bvModal, newData, () => {
        })
        if (newData['current_path'] && oldData) {
          const synchPass = newData['current_path'].replace('customer', 'florist')
          if (synchPass !== this.$route.path) {
            return this.$router.push(synchPass)
          }
        }

        if (!fstore.getters.isOperationPossible) {
          if (newData['event'] === 'click') {
            if (newData['id'] === 'next') {
              this.signalingNextPage(newData['target_path'])
            }
            if (newData['id'] === 'back') {
              this.backPage(newData['target_path'])
            }
          }

          if (newData['event'] === 'input') {
            for (var i = 0; i < newData['data'].length; i++) {
              if (newData['data'][i] && newData['data'][i].id) {
                let elm = document.getElementById(newData['data'][i].id)
                if (elm.name === 'shinroShinpu1' || elm.name === 'shinroShinpu2') {
                  elm.checked = (elm.value === newData['data'][i].value)
                  elm.dispatchEvent(new Event('change'))
                } else if (newData['data'][i].target) {
                  elm.value = newData['data'][i].value
                  elm.dispatchEvent(new Event('input'))
                  // customer側で変更した値に対してvalidationを実行するためにchangeイベントを発火する
                  elm.dispatchEvent(new Event('change'))
                } else {
                  elm.value = newData['data'][i].value
                  elm.dispatchEvent(new Event('input'))
                }
              }
            }
          }
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    getIsOperationPossible: function (bool) {
      if (bool) {
        this.isOperationPossible = true
      } else {
        this.isOperationPossible = false
      }
    }
  },
  methods: {
    setApiData: async function () {
      try {
        const resData = await CustomerInfoModel.apiSetStore(this.$bvModal, () => {})
        console.log(resData)
        this.bothFamilyName1 = resData.bothFamilyName1
        this.bothFamilyName2 = resData.bothFamilyName2
        this.groomLastName = resData.groomLastName
        this.groomFirstName = resData.groomFirstName
        this.groomLastNameKana = resData.groomLastNameKana
        this.groomFirstNameKana = resData.groomFirstNameKana
        this.groomPhoneNumber = resData.groomPhoneNumber
        this.brideLastName = resData.brideLastName
        this.brideFirstName = resData.brideFirstName
        this.brideLastNameKana = resData.brideLastNameKana
        this.brideFirstNameKana = resData.brideFirstNameKana
        this.bridePhoneNumber = resData.bridePhoneNumber
        this.mailAddress = resData.mailAddress
        this.brideMailAddress = resData.brideMailAddress
        this.shinroShinpu1 = resData.shinroShinpu1
        this.shinroShinpu2 = resData.shinroShinpu2
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    sendSignalingInputData: async function (e) {
      try {
        if (this.isOperationPossible) {
          if (typeof e !== 'undefined' && e.type === 'blur') {
            this.$validate(e.target.id)
          }
          const inputs = document.querySelectorAll('input.meeting-input')
          let sendData = []
          for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].name === 'shinroShinpu1' || inputs[i].name === 'shinroShinpu2') {
              if (inputs[i].checked) {
                sendData[i] = {'id': inputs[i].id, 'value': inputs[i].value}
              }
            } else if (typeof e !== 'undefined' && inputs[i].id === e.target.id) {
              sendData[i] = {'target': e.target.id, 'id': inputs[i].id, 'value': inputs[i].value}
            } else {
              sendData[i] = {'id': inputs[i].id, 'value': inputs[i].value}
            }
          }
          SignalingModel.sendInputEvent(this, sendData)
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    nextPage: async function () {
      // cookieの打合せIDが変化しているかチェック
      let cookieProjectNumberCheckResult = await this.$refs.commonRef.cookieProjectNumberCheck()
      if (!cookieProjectNumberCheckResult) {
        this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
        return
      }
      let isError = await this.$validate()
        .then((success) => {
          return !success
        })

      const targetPath = '/florist/meeting/confirm'
      try {
        SignalingModel.sendClickEvent('next', this, {'target_path': targetPath.replace('florist', 'customer')})

        if (isError) {
          return false
        }
        // 空白文字のみの入力の可能性がある為、メールアドレスの空白文字を削除する
        this.mailAddress = this.mailAddress.trim()
        this.brideMailAddress = this.brideMailAddress.trim()

        fstore.commit('setBothFamilyName1', this.bothFamilyName1)
        fstore.commit('setBothFamilyName2', this.bothFamilyName2)
        fstore.commit('setGroomLastName', this.groomLastName)
        fstore.commit('setGroomFirstName', this.groomFirstName)
        fstore.commit('setGroomLastNameKana', this.groomLastNameKana)
        fstore.commit('setGroomFirstNameKana', this.groomFirstNameKana)
        fstore.commit('setGroomPhoneNumber', this.groomPhoneNumber)
        fstore.commit('setBrideLastName', this.brideLastName)
        fstore.commit('setBrideFirstName', this.brideFirstName)
        fstore.commit('setBrideLastNameKana', this.brideLastNameKana)
        fstore.commit('setBrideFirstNameKana', this.brideFirstNameKana)
        fstore.commit('setBridePhoneNumber', this.bridePhoneNumber)
        fstore.commit('setMailAddress', this.mailAddress)
        fstore.commit('setBrideMailAddress', this.brideMailAddress)
        fstore.commit('setShinroShinpu1', this.shinroShinpu1)
        fstore.commit('setShinroShinpu2', this.shinroShinpu2)
        fstore.commit('setIsOperationPossible', true)
        this.$router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
        return false
      }
    },
    signalingNextPage: async function (targetPath) {
      try {
        let isError = await this.$validate()
          .then((success) => {
            return !success
          })

        if (isError) {
          return false
        }
        fstore.commit('setBothFamilyName1', this.bothFamilyName1)
        fstore.commit('setBothFamilyName2', this.bothFamilyName2)
        fstore.commit('setGroomLastName', this.groomLastName)
        fstore.commit('setGroomFirstName', this.groomFirstName)
        fstore.commit('setGroomLastNameKana', this.groomLastNameKana)
        fstore.commit('setGroomFirstNameKana', this.groomFirstNameKana)
        fstore.commit('setGroomPhoneNumber', this.groomPhoneNumber)
        fstore.commit('setBrideLastName', this.brideLastName)
        fstore.commit('setBrideFirstName', this.brideFirstName)
        fstore.commit('setBrideLastNameKana', this.brideLastNameKana)
        fstore.commit('setBrideFirstNameKana', this.brideFirstNameKana)
        fstore.commit('setBridePhoneNumber', this.bridePhoneNumber)
        fstore.commit('setMailAddress', this.mailAddress)
        fstore.commit('setBrideMailAddress', this.brideMailAddress)
        fstore.commit('setShinroShinpu1', this.shinroShinpu1)
        fstore.commit('setShinroShinpu2', this.shinroShinpu2)
        fstore.commit('setIsOperationPossible', false)
        this.$router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
        return false
      }
    },
    backPage () {
      try {
        const targetPath = '/customer/meeting/agenda'
        SignalingModel.sendClickEvent('back', this, {'target_path': targetPath.replace('customer', 'florist')})
        this.$router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    // backPage (targetPath) {
    //   this.$router.push(targetPath)
    // },
    loadValidate: async function (e) {
      try {
        if (typeof e !== 'undefined') {
          this.$validate(e.target.id)
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    }
  }
}
</script>
<style scoped type="text/css">
  label {
    margin-bottom: 1px;
  }
  input[type=radio] {
    transform: scale(2);
  }
  .form-control:disabled {
    background-color: #fff;
  }
  .next-button-disabled:disabled {
  background-color: rgb(0, 123, 255);
  color: #fff;
  opacity: 1;
  }
  .big_radio {
  accent-color:#007bff;
  top:10px;
  margin-top: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/FloristMeetingInput.vue